import type { RouteObject } from "react-router-dom";

/*
  F06 web_items: the Items view of the 2026-11-03 design (rebuild package 1H). The view loads when it is first opened, so its panes
  and the style sheets they bring are not part of the first download. Who may open the address is in `app/screens.ts`; it is not
  repeated here. The older item screens (`/items/:id` and the live map) are the item module's and the session module's.
*/

export const routes: RouteObject[] = [{ path: "/items", lazy: async () => ({ Component: (await import("./ItemsView")).ItemsView }) }];
